module.exports = __webpack_public_path__ + "img/web1.8491f5a1.png";